import { Chip, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import DashboardTodoPanel from "./DashboardTodoPanel";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

/**
 * City drill-down shell for a selected province — uses GetTopCities when available.
 */
const CityDrillDownPanel = ({
  loading,
  error,
  data,
  provinceId,
  provinceTitle,
  onRetry,
}) => {
  const isAvailable = pick(data, "isAvailable", "IsAvailable");
  const cities = data?.cities || data?.Cities || [];

  if (!provinceId) {
    return (
      <DashboardTodoPanel
        title="Drill-down شهر"
        futureEndpoints={["GetTopCities"]}
        description="برای مشاهده شهرها، یک استان را از جدول رتبه‌بندی یا نقشه انتخاب کنید."
      />
    );
  }

  if (!isAvailable && !loading && !error) {
    return (
      <DashboardTodoPanel
        title={`شهرهای ${provinceTitle || "استان انتخاب‌شده"}`}
        futureEndpoints={["GetTopCities"]}
        description="جدول شهرهای برتر پس از پیاده‌سازی API GetTopCities فعال می‌شود."
      />
    );
  }

  return (
    <ManagementWidgetShell
      title={`شهرهای ${pick(data, "provinceTitle", "ProvinceTitle") || provinceTitle}`}
      subheader="Drill-down جغرافیایی"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1}>
        {cities.map((city) => {
          const id = pick(city, "cityId", "CityId");
          const href = buildDrillDownHref(pick(city, "drillDown", "DrillDown"));
          return (
            <Stack
              key={id}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1 }}
            >
              {href ? (
                <Typography component={RouterLink} to={href} color="primary" fontWeight={600}>
                  {pick(city, "cityTitle", "CityTitle")}
                </Typography>
              ) : (
                <Typography fontWeight={600}>{pick(city, "cityTitle", "CityTitle")}</Typography>
              )}
              <Chip size="small" label={`${pick(city, "requestCount", "RequestCount") ?? 0} درخواست`} />
            </Stack>
          );
        })}
        {!cities.length && !loading ? (
          <Typography color="text.secondary">شهری برای این استان یافت نشد.</Typography>
        ) : null}
      </Stack>
    </ManagementWidgetShell>
  );
};

export default CityDrillDownPanel;
